import * as React from "react";
import PropTypes from "prop-types";
import { Chip, Box } from "@mui/material";
// import DoneIcon from "@mui/icons-material/Done";

const ChipList = ({ data, variant, handleToggle }) => {
  const [chips, setChips] = React.useState(
    data.map((o) => {
      return { name: o, toggle: false };
    })
  );
  const allowToggle = !!handleToggle;

  return (
    <Box p={2}>
      {chips.map((item, index) => (
        <Box
          component="span"
          key={index}
          sx={{ display: "inline-block", m: 0.5 }}
        >
          <Chip
            label={item.name}
            variant={variant}
            size={"small"}
            color={"primary"}
            sx={{ minWidth: "80px" }}
            clickable={allowToggle}
            // icon={<DoneIcon />}
          />
        </Box>
      ))}
    </Box>
  );
};

ChipList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
};

ChipList.defaultProps = {
  data: ["Loading"],
  variant: "filled", // outlined
  handleToggle: null, // outlined
};

export default ChipList;
